export default {"src":"/_next/static/media/reading-book.mono.c6636fbb.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};